import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="confidence-slider"
export default class extends Controller {
  static targets = ["slider", "hiddenField"]

  connect() {
    this.updateConfidence(this.sliderTarget.value)
  }

  updateConfidence(value) {
    const intValue = parseInt(value)
    this.hiddenFieldTarget.value = intValue
  }

  sliderChanged(event) {
    this.updateConfidence(event.target.value)
  }
}
